export default "__VITE_ASSET__o2ttN$T3__"